import styled from 'styled-components';
import Image from 'assets/images/NotFound.svg';
import { SimpleNavBarExternal } from 'components/NavBar';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 24px;
  padding-top: 81px;
  ${({ theme }) => theme.breakPoints.desktop} {
    padding-top: 159px;
  }
`;

const Content = styled.div`
  text-align: center;
  max-width: 340px;
  ${({ theme }) => `
    ${theme.breakPoints.desktop} {
      max-width: 648px;
    }
  `}
`;

const MainText = styled.h1`
  color: ${({ theme }) => theme.colors.textColors.primaryDark};
  font-family: 'Ivar Fine Light';
  font-size: 3.6rem;
  line-height: 4rem;
  margin: 24px 0;
  max-width: 630px;
  font-weight: 400;
  ${({ theme }) => `
    ${theme.breakPoints.desktop} {
      font-size: 5.6rem;
      line-height: 64px;    
    }
  `}
`;

const SubText = styled.p`
  font-family: 'Moderat';
  font-style: normal;
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 2.8rem;
  max-width: 478px;
  text-align: center;
  margin: 0 auto;
  color: ${({ theme }) => theme.colors.textColors.secondaryDark};
  ${({ theme }) => `
    ${theme.breakPoints.desktop} {
      font-size: 1.8rem;
      line-height: 2.4rem;    
    }
  `}
`;

const StyledImage = styled.img`
  width: 100px;
  ${({ theme }) => theme.breakPoints.desktop} {
    width: 130px;
  }
`;

export default function ErrorPage() {
  return (
    <>
      <SimpleNavBarExternal color="light" to="https://commonsclinic.com/" />
      <Container>
        <Content>
          <StyledImage src={Image} alt="Error page image" />
          <MainText>We can’t find what you’re looking for</MainText>
          <SubText>
            Check back later or call us at 310-595-1030 with any questions or
            concerns.
          </SubText>
        </Content>
      </Container>
    </>
  );
}
